/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef, useEffect } from 'react';
import { Picker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import './emoji-picker.scss';
import { Images } from '../../../../app-constants';
import { OverlayTooltip, Placement } from '../../overlay';

type IProps = {
  onEmojiChange: (data: any) => void;
  showEmojiPicker: boolean;
  onClick: () => void;
  closeEmojiPicker: () => void;
  forUnsubscribe?: boolean;
  whatsappEmojiPicker?: boolean;
  disabled?: boolean;
};

const outClickHook = (ref, onClick) => {
  useEffect(() => {
    /**
     * Function handle for outside click
     */
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClick();
      }
    };

    // Binding the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbinding the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
};

const EmojiPicker: React.FC<IProps> = ({
  onEmojiChange,
  showEmojiPicker,
  onClick,
  closeEmojiPicker,
  forUnsubscribe,
  whatsappEmojiPicker,
  disabled = false,
}) => {
  const emojiRef = useRef(null);
  outClickHook(emojiRef, closeEmojiPicker);
  return (
    <div ref={emojiRef} className="d-flex justify-content-center">
      {whatsappEmojiPicker ? (
        <OverlayTooltip text="Emoji" placement={Placement.Bottom}>
          <img
            className="emoji-icon"
            src={Images.MoodSmileIcon}
            alt="emoji"
            onClick={onClick}
            style={{
              color: forUnsubscribe && 'black',
              cursor: disabled ? 'not-allowed' : 'pointer',
            }}
          />
        </OverlayTooltip>
      ) : (
        <img
          className="emoji-icon"
          src={Images.SmileIcon}
          alt="emoji"
          onClick={onClick}
          style={{
            color: forUnsubscribe && 'black',
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
        />
      )}

      {showEmojiPicker && (
        <Picker
          title=""
          showPreview={false}
          onSelect={onEmojiChange}
          emoji=""
          showSkinTones={false}
          style={
            whatsappEmojiPicker
              ? {
                  position: 'absolute',
                  zIndex: 2,
                  right: '400px',
                  top: '2.2rem',
                }
              : { position: 'absolute', zIndex: 2, right: 0, top: '2rem' }
          }
        />
      )}
    </div>
  );
};

export default EmojiPicker;
